export const microCharges = {
  validAntifraud: 'customerEndpoint/antifraud/validate',
  generateMicroCharge: 'customerEndpoint/micro-charge/generate',
  validateMicroCharge: 'customerEndpoint/micro-charge/validate'
};
